import { useMutation, useQuery } from 'react-query';
import { horseGroupsService } from '../services/horse-groups.service';
import { HorseGroup } from './models/horse-group.model';

export function useHorseGroupsQuery() {
  return useQuery<HorseGroup[]>(["horse-groups"], () => horseGroupsService.getAllActive(), {
    select: (arr) => [...arr].sort((a,b)=> a.name.localeCompare(b.name, 'pl'))
  });
}

export function useActiveHorseGroupsAsSelectOptionQuery() {
  return useQuery(
    ["horse-groups", "horse-groups-options"],
    () => horseGroupsService.getAllActiveAsOptions(), {
      select: (arr: any[]) => [...arr].sort((a,b)=> (a.label ?? '').toString().localeCompare((b.label ?? '').toString(), 'pl'))
    }
  )
}

export function useAddHorseGroupMutation() {
  return useMutation((request: HorseGroup) => horseGroupsService.add(request));
}
export function useEditHorseGroupMutation() {
  return useMutation((request: HorseGroup) => horseGroupsService.edit(request));
}
export function useDeleteHorseGroupMutation() {
  return useMutation((id: number) => horseGroupsService.delete(id));
}
